import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { StripeCustomer } from './stripe-customer.entity';

export class CreateStripeCustomerDto extends Omit(
    StripeCustomer,
    [...BaseEntityFieldsArray, 'providerId'],
    ['providerId', 'stripeConnectedAccount'],
) {}
